import React, { useState, useEffect } from "react";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import Modal from "react-bootstrap/Modal";
import { BASEAPIURL, token } from "../../env";

export default function Affiliation() {
  const [fileName, setFileName] = useState("Choose a file");
  const [fileBase64, setFileBase64] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
   const [searchName, setSearchName] = useState('');

  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [showSM, setShowSM] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    city: "",
    address: "",
    phone: "",
    mobile: "",
    email: "",
  });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchAffiliations();
  }, []);

  const fetchAffiliations = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BASEAPIURL}/AffiliationClubListWithOutImage`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: token }),
      });
      const result = await response.json();
      setData(Array.isArray(result?.data) ? result.data : []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Only image files allowed");
      return;
    }

    setFileName(file.name);
    setPreviewURL(URL.createObjectURL(file));

    const reader = new FileReader();
    reader.onload = () => {
      try {
        const base64 = reader.result.split(",")[1];
        const cleanBase64 = base64.replace(/\s/g, "").replace(/[^A-Za-z0-9+/=]/g, "");
        atob(cleanBase64); // validation
        setFileBase64(cleanBase64);
      } catch {
        alert("Invalid image format");
        setFileBase64(null);
        setFileName("Choose a file");
        setPreviewURL(null);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e, isEdit = false) => {
    e.preventDefault();
    try {
      const response = await fetch(`${BASEAPIURL}/UploadAffiliationClub`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tokenData: token,
          AC_s: [{ ...formData, ImageBase64: fileBase64 }],
        }),
      });

      const result = await response.json();
      if (result?.status) {
        alert(`Affiliation ${isEdit ? "updated" : "added"} successfully!`);
        setFormData({ name: "", city: "", address: "", phone: "", mobile: "", email: "" });
        setFileBase64(null);
        setPreviewURL(null);
        setFileName("Choose a file");
        isEdit ? setShow2(false) : setShow(false);
        fetchAffiliations();
      } else {
        alert("Something went wrong!");
      }
    } catch (err) {
      console.error(err);
      alert("Submission failed");
    }
  };

  const handleEdit = (item) => {
    setFormData({
      name: item.Name || "",
      city: item.City || "",
      address: item.Address || "",
      phone: item.Phone || "",
      mobile: item.Mobile || "",
      email: item.Email || "",
    });
    setShow2(true);
  };

  const handleDeleteConfirm = (id) => {
    setDeleteId(id);
    setShowSM(true);
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(`${BASEAPIURL}/DeleteAffiliationClub`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: token, ID: deleteId }),
      });
      const result = await response.json();
      if (result?.status) {
        alert("Deleted successfully!");
        setShowSM(false);
        fetchAffiliations();
      } else {
        alert("Failed to delete.");
      }
    } catch (error) {
      console.error(error);
      alert("Error deleting item.");
    }
  };

   const filteredAffiliation = data.filter((item) => item.Name.toLowerCase().includes(searchName.toLowerCase()));

  const paginatedData = filteredAffiliation.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(filteredAffiliation.length / itemsPerPage);

  return (
    <>
      <div className="row d-flex justify-content-between align-items-center mb-2 g-0 py-2">
        <div className="col-4">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search..."
            value={searchName}
                onChange={(e) => {
                  setSearchName(e.target.value);
                  setCurrentPage(1);
                }}
          />
         
        </div>
        {/* <div
          onClick={() => setShow(true)}
          className="col-2 d-flex justify-content-center align-items-center p-2 rounded-1"
          style={{
            backgroundColor: "#000",
            fontWeight: 400,
            color: "#fff",
            cursor: "pointer",
          }}
        >
          + Add
        </div> */}
      </div>

{/* Desktop Table View */}
<div className="row mt-2 d-none d-md-block">
  <div className="col-12 m-auto">
    <div className="card-list-box-sr card p-2 border-0">
      <div className="w-full overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <table className="table table-bordered table-hover align-middle">
            <thead className="bg-dark text-white">
              <tr>
                <th style={{ width: "60px" }}>ID</th>
                <th style={{ maxWidth: "150px" }}>Name</th>
                <th style={{ maxWidth: "250px" }}>Address</th>
                <th style={{ maxWidth: "150px" }}>Mobile</th>
                <th style={{ maxWidth: "150px" }}>Phone</th>
                <th style={{ width: "100px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    Loading...
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="6" className="text-center text-danger">
                    Error loading data: {error.message}
                  </td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    No data available
                  </td>
                </tr>
              ) : (
                paginatedData.map((item, index) => (
                  <tr key={item.ID || index}>
                    <td>{item.ID || "N/A"}</td>
                    <td
                      className="text-truncate text-start"
                      style={{ maxWidth: "150px" }}
                      title={item.Name || "N/A"}
                    >
                      {item.Name || "N/A"}
                    </td>
                    <td
                      className="text-truncate text-start"
                      style={{ maxWidth: "250px" }}
                      title={item.Address || "N/A"}
                    >
                      {item.Address || "N/A"}
                    </td>
                    <td
                      className="text-truncate text-start"
                      style={{ maxWidth: "150px" }}
                      title={item.Mobile || "N/A"}
                    >
                      {item.Mobile || "N/A"}
                    </td>
                    <td
                      className="text-truncate text-start"
                      style={{ maxWidth: "150px" }}
                      title={item.Phone || "N/A"}
                    >
                      {item.Phone || "N/A"}
                    </td>
                    <td className="d-flex gap-2">
                      <FaEdit
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleEdit(item)}
                      />
                      {/* <MdDelete
                        className="text-danger"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDeleteConfirm(item.ID)}
                      /> */}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {data.length > itemsPerPage && !loading && !error && (
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  </div>
</div>

{/* Mobile/Tablet Card View */}
<div className="row mt-2 d-block d-md-none">
  {loading ? (
    <div className="text-center text-muted w-100">Loading...</div>
  ) : error ? (
    <div className="text-center text-danger w-100">
      Error loading data: {error.message}
    </div>
  ) : paginatedData.length === 0 ? (
    <div className="text-center text-muted w-100">No data available</div>
  ) : (
    paginatedData.map((item, index) => (
      <div
        key={item.ID || index}
        className="card mb-3 shadow-sm"
        style={{ cursor: "default" }}
      >
        <div className="card-body p-3">
          <h5 className="card-title mb-1 text-truncate" title={item.Name || "N/A"}>
            {item.Name || "N/A"}
          </h5>
          <p className="card-text mb-1 text-truncate" title={item.ID || "N/A"}>
            <strong>ID:</strong> {item.ID || "N/A"}
          </p>
          <p
            className="card-text mb-1 text-truncate"
            style={{ maxWidth: "200px" }}
            title={item.Address || "N/A"}
          >
            <strong>Address:</strong> {item.Address || "N/A"}
          </p>
          <p
            className="card-text mb-1 text-truncate"
            style={{ maxWidth: "200px" }}
            title={item.Mobile || "N/A"}
          >
            <strong>Mobile:</strong> {item.Mobile || "N/A"}
          </p>
          <p
            className="card-text mb-3 text-truncate"
            style={{ maxWidth: "200px" }}
            title={item.Phone || "N/A"}
          >
            <strong>Phone:</strong> {item.Phone || "N/A"}
          </p>
          <div className="d-flex gap-3 justify-content-end">
            <FaEdit
              className="text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(item)}
              title="Edit"
            />
            <MdDelete
              className="text-danger"
              style={{ cursor: "pointer" }}
              onClick={() => handleDeleteConfirm(item.ID)}
              title="Delete"
            />
          </div>
        </div>
      </div>
    ))
  )}

  {/* Pagination */}
  {data.length > itemsPerPage && !loading && !error && (
    <div className="d-flex justify-content-between align-items-center mt-3 px-2">
      <button
        className="btn btn-outline-secondary btn-sm"
        disabled={currentPage === 1}
        onClick={() => setCurrentPage((prev) => prev - 1)}
      >
        Previous
      </button>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <button
        className="btn btn-outline-secondary btn-sm"
        disabled={currentPage === totalPages}
        onClick={() => setCurrentPage((prev) => prev + 1)}
      >
        Next
      </button>
    </div>
  )}
</div>


      {/* Add Modal */}
      <Modal show={show} onHide={() => {
        setShow(false);
        setPreviewURL(null);
        setFileBase64(null);
        setFileName("Choose a file");
      }} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add Affiliation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormComponent
            fileName={fileName}
            previewURL={previewURL}
            handleFileChange={handleFileChange}
            onClose={() => {
              setShow(false);
              setPreviewURL(null);
              setFileBase64(null);
              setFileName("Choose a file");
            }}
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isEdit={false}
          />
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={show} onHide={() => setShow(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Affiliation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormComponent
                fileName={fileName}
                fileUrl={previewURL}
                handleFileChange={handleFileChange}
                onClose={() => setShow(false)}
                formData={formData}
                setFormData={setFormData}
                handleSubmit={(e) => handleSubmit(e, false)}
              />
            </Modal.Body>
          </Modal>

          <Modal show={show2} onHide={() => setShow2(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Edit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormComponent
                fileName={fileName}
                fileUrl={previewURL}
                handleFileChange={handleFileChange}
                onClose={() => setShow2(false)}
                formData={formData}
                setFormData={setFormData}
                handleSubmit={(e) => handleSubmit(e, true)}
                isEdit={true}
              />
            </Modal.Body>
          </Modal>

      {/* Delete Confirmation */}
      <Modal size="sm" show={showSM} onHide={() => setShowSM(false)}>
        <Modal.Header closeButton>
          <Modal.Title><FiAlertTriangle style={{ color: "orangered" }} /></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">Are you sure you want to delete?</div>
          <div className="d-flex justify-content-between mt-3">
            <button className="btn btn-success w-100 me-2" onClick={handleDelete}>Yes</button>
            <button className="btn btn-danger w-100" onClick={() => setShowSM(false)}>No</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const FormComponent = ({
  fileName,
  previewURL,
  handleFileChange,
  onClose,
  formData,
  setFormData,
  handleSubmit,
  isEdit = false,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label>Name</label>
        <input
          type="text"
          className="form-control"
          value={formData.name}
          onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
          required
        />
      </div>
      <div className="mb-3">
        <label>City</label>
        <input
          type="text"
          className="form-control"
          value={formData.city}
          onChange={(e) => setFormData((prev) => ({ ...prev, city: e.target.value }))}
          required
        />
      </div>
      <div className="mb-3">
        <label>Address</label>
        <textarea
          className="form-control"
          rows={3}
          value={formData.address}
          onChange={(e) => setFormData((prev) => ({ ...prev, address: e.target.value }))}
          required
        />
      </div>
      <div className="mb-3">
        <label>Phone</label>
        <input
          type="text"
          className="form-control"
          value={formData.phone}
          onChange={(e) => setFormData((prev) => ({ ...prev, phone: e.target.value }))}
        />
      </div>
      <div className="mb-3">
        <label>Mobile</label>
        <input
          type="text"
          className="form-control"
          value={formData.mobile}
          onChange={(e) => setFormData((prev) => ({ ...prev, mobile: e.target.value }))}
        />
      </div>
      <div className="mb-3">
        <label>Email</label>
        <input
          type="email"
          className="form-control"
          value={formData.email}
          onChange={(e) => setFormData((prev) => ({ ...prev, email: e.target.value }))}
        />
      </div>
      <div className="mb-3">
        <label>Upload Image</label>
        <input type="file" className="form-control" onChange={handleFileChange} accept="image/*" />
        <small className="form-text text-muted">{fileName}</small>
        {previewURL && <img src={previewURL} alt="Preview" className="mt-2" style={{ maxHeight: 150 }} />}
      </div>
      <div className="d-flex justify-content-end gap-2">
        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
        <button type="submit" className="btn btn-primary">{isEdit ? "Update" : "Add"}</button>
      </div>
    </form>
  );
};
